import actions from './actions';

const {
    switchType
} = actions;

export { switchType };
